export const ageMethod = "age nearest";
export const gateway = "https://qat-mitch-shopper-api.link-nonprod.wawanesalife.com";
export const assets = "https://qat-assets.link-nonprod.wawanesalife.com/brokers/mitch";
export const googleApiKey = "AIzaSyD8GAXLH7FxUmF13tfHgXVAU6fWk66UH3k";
export const appToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJtaXRjaCIsIm5hbWUiOiJtaXRjaCIsImlhdCI6MTc4MDU4MTE1NiwiZXhwIjoxOTM4MzY5MTU2fQ.YUziWBxi6uSYYXndK-ysclfEl2Mdk5RPYNn4wO2T2Ss";
export const brokerConfig = {
	enabled: "yes",
	"split": '0.6'
};
export const brokerBranding = {
	"qat-mitch-shopper.link-nonprod.wawanesalife.com": {
		a: {
			approve_company: "Link Platform",
			approve_user: "link_mitch",
			brands: [
				"qat-mitch-shopper.link-nonprod.wawanesalife.com",
			],
			broker: "mitch",
			broker_formatted_name: "Mitch Insurance",
			email: "info@mitchinsurance.com",
			environment: "qat",
			environment_id: "qat",
			formLabels: "hide",
			g4: "G-2QM64W4BM4",
			layout: "modern",
			logoPosition: "menu",
			map1: [
				"1555 Wentworth St. Unit 200, Whitby",
				"Whitby",
				"ON",
				"L1N 9T6",
			],
			map2: [
				"110 Yonge St. Suite 403",
				"Toronto",
				"ON",
				"M5C 1T4",
			],
			map3: "hide",
			map4: "hide",
			menuEmail: "none",
			menuPhone: "button",
			phone: "1-800-731-2228",
			photo1: "show",
			photo2: "show",
			photo3: "show",
			photo4: "show",
			privacyLink: "https://mitchinsurance.com/privacy-policy/",
			progressMode: "steady",
			split: "0.5",
			tagline: "Say hi to lovable insurance!",
			tcLink: "https://mitchinsurance.com/terms-conditions/",
			themeSwitcher: "hide",
			website: "https://mitchinsurance.com",
			scope: "mitch#branding#qat-mitch-shopper.link-nonprod.wawanesalife.com#a",
			ab: "a",
			logo: "a.png",
			brand_name: "qat-mitch-shopper.link-nonprod.wawanesalife.com",
		},
		b: {
			approve_company: "Link Platform",
			approve_user: "link_mitch",
			brands: [
				"qat-mitch-shopper.link-nonprod.wawanesalife.com",
			],
			broker: "mitch",
			broker_formatted_name: "Mitch Insurance",
			email: "info@mitchinsurance.com",
			environment: "qat",
			environment_id: "qat",
			formLabels: "hide",
			g4: "G-2QM64W4BM4",
			layout: "modern",
			logoPosition: "menu",
			map1: [
				"1555 Wentworth St. Unit 200, Whitby",
				"Whitby",
				"ON",
				"L1N 9T6",
			],
			map2: [
				"110 Yonge St. Suite 403",
				"Toronto",
				"ON",
				"M5C 1T4",
			],
			map3: "hide",
			map4: "hide",
			menuEmail: "none",
			menuPhone: "button",
			phone: "1-800-731-2228",
			photo1: "show",
			photo2: "show",
			photo3: "show",
			photo4: "show",
			privacyLink: "https://mitchinsurance.com/privacy-policy/",
			progressMode: "steady",
			split: "0.5",
			tagline: "Say hi to lovable insurance!",
			tcLink: "https://mitchinsurance.com/terms-conditions/",
			themeSwitcher: "hide",
			website: "https://mitchinsurance.com",
			scope: "mitch#branding#qat-mitch-shopper.link-nonprod.wawanesalife.com#b",
			ab: "b",
			logo: "b.png",
			brand_name: "qat-mitch-shopper.link-nonprod.wawanesalife.com",
		},
	},
};

//updated on Thu Jun 04 2026 13:52:36 GMT+0000 (Coordinated Universal Time)
